import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { getWeekDates, isToday, isSelected, formatDate, formatDateForLocal } from '../../utils/dateUtils';

const DateSelector = ({
  selectedDate,
  onDateSelect,
  currentWeek,
  onWeekChange,
  className = "",
  showWeekNavigation = true
}) => {
  const weekDates = getWeekDates(currentWeek);
  
  console.log('🔍 DateSelector Debug:', {
    currentWeek: currentWeek,
    selectedDate: selectedDate,
    weekDates: weekDates.map(d => d.toISOString().split('T')[0])
  });

  return (
    <div className={className}>
      {/* Navegación de semanas */}
      {showWeekNavigation && (
        <div className="flex items-center justify-between mb-4">
          <button
            onClick={() => onWeekChange(-1)}
            className="p-2 hover:bg-gray-100 rounded transition"
          >
            <FaChevronLeft className="text-gray-600" />
          </button>
          <span className="text-sm font-medium text-gray-700">
            Semana del {weekDates[0].toLocaleDateString('es-ES', { day: 'numeric', month: 'long' })} al {weekDates[6].toLocaleDateString('es-ES', { day: 'numeric', month: 'long' })}
          </span>
          <button
            onClick={() => onWeekChange(1)}
            className="p-2 hover:bg-gray-100 rounded transition"
          >
            <FaChevronRight className="text-gray-600" />
          </button>
        </div>
      )}

      {/* Días de la semana */}
      <div className="grid grid-cols-7 gap-2">
        {weekDates.map((date, index) => (
          <button
            key={index}
            onClick={() => {
              const formattedDate = formatDateForLocal(date);
              console.log('🔍 DateSelector Debug:', {
                originalDate: date,
                formattedDate: formattedDate,
                dayOfWeek: date.getDay(),
                dayName: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'][date.getDay()]
              });
              onDateSelect(formattedDate);
            }}
            className={`
              p-3 rounded-lg text-sm font-medium transition-all duration-200
              ${isSelected(date, selectedDate)
                ? 'bg-indigo-600 text-white shadow-lg scale-105'
                : isToday(date)
                ? 'bg-indigo-100 text-indigo-600 border-2 border-indigo-300'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:scale-105'
              }
            `}
          >
            <div className="text-xs text-gray-500 mb-1">
              {date.toLocaleDateString('es-ES', { weekday: 'short' })}
            </div>
            <div className="font-semibold">
              {date.getDate()}
            </div>
            {isToday(date) && (
              <div className="text-xs mt-1 text-indigo-600 font-medium">
                Hoy
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DateSelector; 